/**
 * Carrusel del hero de portada.
 *
 * Solo cruza las fotos de fondo: el titular, el texto y el botón no se mueven.
 * El carrusel de julio cambiaba también el texto cada tres segundos, que no da
 * tiempo a leer un titular y un botón, y por eso se retiró.
 *
 * Se para solo cuando la pestaña no está visible y cuando el hero sale de
 * pantalla, para no gastar batería animando algo que nadie está mirando.
 */

/** Texto visible traducible (window.tmI18n); si falta, vale el español. */
function tr(key, fallback, vars) {
  const t = (window.tmI18n && window.tmI18n[key]) || fallback;
  return vars ? t.replace(/\{\{(\w+)\}\}/g, (_, n) => (vars[n] !== undefined ? vars[n] : '')) : t;
}


class MuralHeroSlides extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.mural-hero__bg')];
    if (this.slides.length < 2) return;

    this.index = 0;
    this.paused = false;
    this.interval = Math.max(3, Number(this.dataset.interval) || 3) * 1000;

    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.pauseButton = this.querySelector('[data-hero-pause]');

    this.pauseButton?.addEventListener('click', () => this.toggle());
    this.onVisibility = () => (document.hidden ? this.stop() : this.start());
    document.addEventListener('visibilitychange', this.onVisibility);

    // Fuera de pantalla no se anima nada.
    this.observer = new IntersectionObserver(
      ([entry]) => (entry.isIntersecting ? this.start() : this.stop()),
      { threshold: 0.15 }
    );
    this.observer.observe(this);

    // Quien pide menos movimiento ve la primera foto y ya. El botón de pausa
    // se esconde porque no hay nada que pausar.
    if (this.reduced.matches) {
      this.paused = true;
      if (this.pauseButton) this.pauseButton.hidden = true;
      return;
    }

    this.start();
  }

  disconnectedCallback() {
    this.stop();
    this.observer?.disconnect();
    if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
  }

  start() {
    if (this.timer || this.paused || !this.slides || this.slides.length < 2) return;
    this.timer = setInterval(() => this.next(), this.interval);
  }

  stop() {
    if (!this.timer) return;
    clearInterval(this.timer);
    this.timer = null;
  }

  toggle() {
    this.paused = !this.paused;
    if (this.paused) this.stop();
    else this.start();

    if (this.pauseButton) {
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.setAttribute(
        'aria-label',
        this.paused ? tr('hero_resume', 'Reanudar el cambio automático de imagen') : tr('hero_pause', 'Pausar el cambio automático de imagen')
      );
      this.pauseButton.classList.toggle('is-paused', this.paused);
    }
  }

  next() {
    const previous = this.slides[this.index];
    this.index = (this.index + 1) % this.slides.length;
    previous?.classList.remove('is-active');
    this.slides[this.index]?.classList.add('is-active');
  }
}

if (!customElements.get('mural-hero-slides')) {
  customElements.define('mural-hero-slides', MuralHeroSlides);
}
